module.exports = __webpack_public_path__ + "static/media/location.082f1104.png";